import { getWithAuth } from './request';
import { getRandomInt } from './common';
import { encodeMsg, decodeMsg, Any, Msg } from '@/proto/connector_message.pb';
import { encodeAuth, decodeAuthAck } from '@/proto/connector_auth.pb';
// import { encodeLiveConnectorChangeRoom, decodeLiveMsgs } from '@/proto/live_connector.pb';
// import { decodeLuckyWheelLightUpdate } from '@/proto/live_messages.pb';
import eventBus from './eventBus';

const encodeSendMsg = (type, type_url = '', data?: Uint8Array): Uint8Array => {
  const anyData: Any = {
    type_url,
    value: data,
  };
  return encodeMsg({
    type,
    data: anyData,
  });
};

const decodeRecieveMsg = async (data: Blob): Promise<Msg> => {
  // 浏览器兼容问题，不支持arrayBuffer
  // const buffer = await data.arrayBuffer();
  // const rtUint8Array = new Uint8Array(buffer);
  // const rt = decodeMsg(rtUint8Array);
  // return rt;
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = function (event) {
      // console.log('event', event.target.result);
      const buffer: ArrayBuffer = event.target.result as ArrayBuffer;
      const rtUint8Array = new Uint8Array(buffer);
      const rt = decodeMsg(rtUint8Array);
      resolve(rt);
    };
    reader.onerror = function (error) {
      reject(error);
    };
    reader.readAsArrayBuffer(data);
  });
};

export class H5WebSocket {
  // https://intl-wiki.p1.cn/pages/viewpage.action?pageId=79790931
  // interval=心跳间隔，retries=心跳丢失次数，timeout=心跳超时时间，完整的是每10秒发送一个ping，当连续发送3个ping再过5秒后还没有收到pong时，本次连接当作失效处理
  // 重连的时候从 webAddrs 里面随机取一个地址重试，同时做退避，在 backoffMin 到backoffMax之间随机取退避间隔（单位是秒）
  socket: WebSocket;
  accessToken: string;
  login: VoidFunction;
  info: {
    close: boolean;
    isConnected: boolean;
    interval: number;
    retries: number;
    timeout: number;
    backoffMin: number;
    backoffMax: number;
    url: string;
    webAddrs: string[];
  };
  pingTimes: number;
  reConnectorTimer: any;
  pingTimer: any;

  constructor(accessToken: string, login: VoidFunction) {
    this.accessToken = accessToken;
    this.login = login;
  }
  async init() {
    if (this.info) {
      return;
    }
    const { data } = await getWithAuth('/web/dispatcher/metadata');
    if (!data?.connector?.webAddrs?.length) {
      return;
    }
    this.info = {
      close: false,
      isConnected: false,
      interval: 30, // data.connector.interval,
      retries: data.connector.keepalive.tries,
      timeout: data.connector.keepalive.timeout,
      backoffMin: data.connector.reconnect.backoffMin,
      backoffMax: data.connector.reconnect.backoffMax,
      webAddrs: data.connector.webAddrs,
      url: data.connector.webAddrs[getRandomInt(0, data.connector.webAddrs.length - 1)],
    };
  }
  async connect() {
    const _this = this;
    await this.init();
    const { info, accessToken } = this;
    if (!info) {
      return;
    }
    try {
      this.socket = new WebSocket(info.url);
      const { socket } = this;

      socket.onopen = function () {
        socket.send(
          encodeSendMsg(
            'authWeb',
            'connector.Auth',
            encodeAuth({
              accessToken,
            })
          )
        );
      };

      socket.onmessage = async function (event) {
        const data = await decodeRecieveMsg(event.data);
        // 心跳检测
        if (data.type === 'pong') {
          _this.pingTimes = 0;
        }
        if (!data.data) {
          return;
        }

        // push消息
        if (data.type === 'push' && data.data.type_url === 'type.googleapis.com/connector.Push') {
          console.log('push message');
          eventBus.emit('conversationUpdate');
        }

        if (data.data.type_url === 'type.googleapis.com/connector.AuthAck') {
          // 鉴权成功
          if (!data.data.value) {
            info.isConnected = true;
            _this.heartBeat();
          } else {
            // 鉴权失败
            _this.close();
            _this.login();
          }
        }
      };

      socket.onclose = function () {
        if (info.close) {
          return;
        }
        info.isConnected = false;
        _this.reConnect();
        // console.log('长链接 close');
      };

      socket.onerror = function (e) {
        console.log('websocket err', e);
        _this.close();
      };
    } catch (e) {
      console.error('websocket err', e);
    }
  }

  heartBeat() {
    const { info, socket } = this;
    this.pingTimes = 0;
    clearInterval(this.pingTimer);
    this.pingTimer = setInterval(() => {
      if (info.isConnected) {
        this.pingTimes++;
        socket.send(encodeSendMsg('ping'));
        // 心跳检测
        if (this.pingTimes >= info.retries) {
          setTimeout(() => {
            if (this.pingTimes >= info.retries) {
              console.log('心跳丢失，关闭连接');
              // socket.close();
            }
          }, info.timeout * 1000);
        }
      }
    }, info.interval * 1000);
  }

  reConnect() {
    const { info } = this;
    const _this = this;
    if (info.isConnected) {
      return;
    }
    info.url = info.webAddrs[getRandomInt(0, info.webAddrs.length - 1)];
    const backoff = getRandomInt(info.backoffMin, info.backoffMax);
    clearTimeout(this.reConnectorTimer);
    // 延迟5s后重连，如果重连失败，会调用onclose方法，重新建立连接
    this.reConnectorTimer = setTimeout(() => {
      console.log('尝试重新连接...');
      _this.connect();
    }, backoff * 1000);
  }
  close() {
    this.info.close = true;
    clearTimeout(this.reConnectorTimer);
    clearInterval(this.pingTimer);
    this.socket && this.socket.close();
  }
}
